export default "__VITE_ASSET__Csg8Jei4__"